<template>
    <Breadcrumbs main="Bonus Ui" title="Pagination" />
    <div class="container-fluid">
        <div class="row">
            <simplePagination />
            <disabledPagination />
            <iconsPagenation />
            <roundedPagination />
            <alignmentsPagination />
            <sizingPagination />
        </div>
    </div>
</template>
<script lang="ts" setup>
import { ref, defineAsyncComponent } from 'vue'
const simplePagination = defineAsyncComponent(() => import("@/components/theme/advance/pagination/simplePagination.vue"))
const disabledPagination = defineAsyncComponent(() => import("@/components/theme/advance/pagination/disabledPagination.vue"))
const iconsPagenation = defineAsyncComponent(() => import("@/components/theme/advance/pagination/iconsPagenation.vue"))
const roundedPagination = defineAsyncComponent(() => import("@/components/theme/advance/pagination/roundedPagination.vue"))
const alignmentsPagination = defineAsyncComponent(() => import("@/components/theme/advance/pagination/alignmentsPagination.vue"))
const sizingPagination = defineAsyncComponent(() => import("@/components/theme/advance/pagination/sizingPagination.vue"))
</script>